export const DEFAULT_QUERY = {
  _pagina: '1',
  _num_x_pagina: '10',
}
